import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from 'components/Layout/Card';
import Table from 'components/Layout/Table';
import {
  getDataFromLocalStorage,
  objectToFormData,
  getEventDate,
  getUserType,
} from 'utils/helpers';
import { limit } from 'utils/constants';
import { fetchAllEvents, fetchNewAllEvents } from 'store/slices';
import { useNavigate } from 'react-router-dom';
import SeachInput from 'components/form/SeachInput';

const EventCertificates = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { eventTypeList } = useSelector((state) => ({
    eventTypeList: state.global.eventTypeList,
  }));

  const [isLoading, setIsLoading] = useState(true);
  const [tableList, setTableList] = useState([]);
  const [searchPayload, setSearchPayload] = useState({
    status: 'Completed',
  });
  const [searchText, setSearchText] = useState('');
  const [timer, setTimer] = useState('');

  const [filterData, setFilterData] = useState({
    total: 0,
    offset: 0,
    limit: limit,
  });

  const handelChangeSearch = (searchData) => {
    setIsLoading(true);
    let newData = filterData;
    setSearchPayload(searchData);
    newData = { ...newData, ...searchData, offset: 0 };
    setFilterData(newData);
    getEvents(newData);
  };

  const handelChangePagination = (offset) => {
    setIsLoading(true);
    let newData = { ...filterData, ...searchPayload };
    newData = { ...newData, offset: offset };
    setFilterData(newData);
    getEvents(newData);
  };

  const getEvents = async (obj) => {
    let forData = objectToFormData(obj);
    const response = await dispatch(fetchNewAllEvents(forData));
    setTableList(response?.data?.events || []);
    setFilterData({
      ...obj,
      total: response?.data?.result_count || 0,
    });
    setIsLoading(false);
  };

      // Debounced search handler
  const handleSearch = (e) => {
    let value = e?.target?.value;
    setSearchText(value);
    let time = timer;
    clearTimeout(time);
    time = setTimeout(() => {
      const updatedSearchPayload = { ...searchPayload, event_name: value };
      setSearchPayload(updatedSearchPayload);
      const updatedFilterData = {
        ...filterData,
        offset: 0,
        ...updatedSearchPayload,
      };
      setIsLoading(true);
      setFilterData(updatedFilterData);
      getEvents(updatedFilterData);
    }, 800);
    setTimer(time);
  };


  useEffect(() => {
    if (['0', '1', '6', '7'].includes(getDataFromLocalStorage('user_type'))) {
      getEvents({ ...filterData, ...searchPayload });
    } else {
      navigate('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const header = [
    {
      isSearch: true,
      isSearchDropdown: true,
      dropdownOptions: { options: eventTypeList, key: 'id', value: 'name' },
      searchInputName: 'event_type',
      title: 'Event Type',
    },
    {
      isSearch: true,
      searchInputName: 'event_name',
      title: 'Event Name',
    },
    {
      isSearch: true,
      isDatePicker: true,
      searchInputName: 'date',
      title: 'Date & Venue',
    },
  ];

  const rowData = [];
  tableList?.forEach((elem) => {
    let obj = [
      {
        value: elem?.event_type,
      },
      {
        value: (
          <div
            className="pointer color-new-car hover-effect"
            onClick={() => {
              navigate(
                `/${getUserType()}/tracking/certificate-management/event-certificates/${
                  elem?.id
                }`
              );
            }}
          >
            {elem?.event_name}
          </div>
        ),
      },
      {
        value: (
          <span>
            <div>{getEventDate(elem.start_date, elem.end_date)}</div>
            {elem?.country_name && (
              <div>{`${elem?.city_name ? `${elem?.city_name},` : ''} ${
                elem?.country_name
              }`}</div>
            )}
          </span>
        ),
      },
    ];
    rowData.push({ data: obj });
  });
  return (
    <div>
      <Card className="cps-20 cpe-20 cpb-20">
        <div className="d-flex justify-content-between align-items-center cpt-28 cpb-28">
          <div className="table-title">All Events ({filterData?.total})</div>
          <div style={{ width: '150px' }} className="me-3">
            <SeachInput
              placeholder="Search Name"
              value={searchText}
              onChange={handleSearch}
              className="small-text-input"
              iconClassName="small-search-icon"
            />
          </div>
        </div>
        <Table
          isLoading={isLoading}
          header={header}
          rowData={rowData}
          filterData={filterData}
          searchPayload={searchPayload}
          searchInputChange={handelChangeSearch}
          changeOffset={handelChangePagination}
        />
      </Card>
    </div>
  );
};
export default EventCertificates;
